  import React, { useEffect, useState } from "react";
  import { useNavigate } from "react-router-dom";
  import { toast } from "react-toastify";
  import { useDispatch } from "react-redux";
  import FingerprintJS from "@fingerprintjs/fingerprintjs";
  import { allapiAction } from "../../Redux/common/action";

  const NewLogin = () => {
    const [userData, setuserData] = useState({});
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [first, setfirst] = useState("");

    const getdetao = async () => {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      setfirst(result.visitorId);
    };

    useEffect(() => {
      getdetao();
    }, []);

    const onChange = (e) => {
      setuserData({ ...userData, [e.target.name]: e.target.value });
    };

    const onSubmit = async (e) => {
      e.preventDefault();

      if (!userData?.phone) {
        toast?.error("Please enter phone");
        return;
      }
      if (!userData?.password) {
        toast?.error("Please enter password");
        return;
      }

      try {
        userData.role_name = "User";
        userData.deviceId = first;

        await dispatch(
          allapiAction.signinSellerCource(userData, navigate)
        );
      } catch (err) {}
    };

    return (
      <div
        style={{
          height: "100dvh", // 🔥 mobile safe height
          width: "100%",
          background:
            "linear-gradient(135deg, rgb(45 96 116), #0a0b0c, rgb(0 7 10))",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden", // 🔥 no scroll
          position: "fixed", // 🔥 no shake
          top: 0,
          left: 0,
        }}
      > 

        <div
          style={{
            width: "92%",
            maxWidth: "360px",
            padding: "25px 18px",
            borderRadius: "18px",
            backdropFilter: "blur(12px)",
            background: "rgba(255,255,255,0.08)",
            border: "1px solid #ffd700",
            boxShadow: "0 8px 25px rgba(0,0,0,0.4)",
            textAlign: "center",
            color: "#fff",
          }}
        >
          {/* Logo */}
          <div
            style={{
              width: "65px",
              height: "65px",
              borderRadius: "50%",
              background: "linear-gradient(135deg, rgb(14 19 56), rgb(20 9 6))",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "24px",
              fontWeight: "bold",
              margin: "0 auto 12px",
              color: "#000",
            }}
          >
          <img src="/img/logo.png" style={{ height: "65px",width:"168px" }}></img>
          </div>

          {/* <h2 style={{ marginBottom: "3px" }}>Eaddy</h2> */}
          <p style={{ fontSize: "12px", opacity: 0.7 }}>
            Learn English Smartly 🚀
          </p>

          {/* Phone */}
          <input
            type="number"
            placeholder="Phone Number"
            name="phone"
            value={userData?.phone || ""}
            onChange={onChange}
            style={{
              width: "100%",
              marginTop: "18px",
              padding: "11px",
              borderRadius: "10px",
              border: "none",
              outline: "none",
              background: "rgba(255,255,255,0.15)",
              color: "#fff",
              fontSize: "14px",
            }}
          />

          {/* Password */}
          <input
            type="password"
            placeholder="Password"
            name="password"
            value={userData?.password || ""}
            onChange={onChange}
            style={{
              width: "100%",
              marginTop: "12px",
              padding: "11px",
              borderRadius: "10px",
              border: "none",
              outline: "none",
              background: "rgba(255,255,255,0.15)",
              color: "#fff",
              fontSize: "14px",
            }}
          />

          {/* Button */}
          <button
            onClick={onSubmit}
            style={{
              width: "100%",
              marginTop: "20px",
              padding: "11px",
              borderRadius: "10px",
              border: "none",
              fontWeight: "bold",
              background:
                "linear-gradient(90deg, #b8860b, #ffd700, #fff3b0, #ffd700, #b8860b)",
              color: "#000000",
              cursor: "pointer",
            }}
          >
            Login
          </button>
        </div>
      </div>
    );
  };

  export default NewLogin;